/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AsyncEcho } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Echo<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name AsyncCreate
   * @request POST:/echo/async
   */
  asyncCreate = (data: AsyncEcho, params: RequestParams = {}) =>
    this.request<AsyncEcho, any>({
      path: `/echo/async`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
